import { Module, Mutation, Action } from 'vuex-module-decorators'
import { find, findIndex } from 'lodash'
import {
  CreateReferenceImageMasterRequest,
  GetReferenceImageMasterByIdRequest,
  ReferenceImageMaster,
  referenceImageMasterApi,
  RemoveReferenceImageMasterByIdRequest,
  UpdateReferenceImageMasterRequest
} from '@/api'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'ReferenceImageMasterStore',
  namespaced: true,
  stateFactory: true
})
export default class ReferenceImageMasterStore extends BaseStore {
  item: ReferenceImageMaster | null = null

  items: ReferenceImageMaster[] = []

  get getItem(): ReferenceImageMaster | null {
    return this.item
  }

  get getItems(): ReferenceImageMaster[] {
    return this.items
  }

  get findById(): (id: number) => ReferenceImageMaster | null {
    return id => {
      return find<ReferenceImageMaster>(this.items, { id }) || null
    }
  }

  @Mutation
  public setItem(item: ReferenceImageMaster | null) {
    this.item = item
  }

  @Mutation
  public addItem(item: ReferenceImageMaster) {
    this.items.push(item)
  }

  @Mutation
  public setItems(items: ReferenceImageMaster[]) {
    this.items = items
  }

  @Mutation
  public updateItem(item: ReferenceImageMaster) {
    const index = findIndex(this.items, { id: item.id })
    this.items.splice(index, 1, item)
  }

  @Mutation
  public removeItemById(id: number) {
    const index = findIndex(this.items, { id })
    this.items.splice(index, 1)
  }

  @Action
  public async fetchById(id: number) {
    const getReferenceImageMasterByIdRequest: GetReferenceImageMasterByIdRequest = {
      id
    }

    const item: ReferenceImageMaster = await referenceImageMasterApi.getReferenceImageMasterById(
      getReferenceImageMasterByIdRequest
    )
    this.setItem(item)
  }

  @Action({ rawError: true })
  public async fetchAll() {
    const items = await referenceImageMasterApi.getAllReferenceImageMaster()
    this.setItems(items)
  }

  @Action({ rawError: true })
  public async create(requestParameters: CreateReferenceImageMasterRequest) {
    const item = await referenceImageMasterApi.create(requestParameters)
    this.addItem(item)
  }

  @Action({ rawError: true })
  public async update(requestParameters: UpdateReferenceImageMasterRequest) {
    const item = await referenceImageMasterApi.update(requestParameters)
    this.updateItem(item)
  }

  @Action({ rawError: true })
  public async remove(id: number) {
    const removeRequest: RemoveReferenceImageMasterByIdRequest = {
      id
    }

    await referenceImageMasterApi.remove(removeRequest)
    this.removeItemById(id)
  }

  @Action({ rawError: true })
  public async upload(requestParameters: UpdateReferenceImageMasterRequest) {
    const item = await referenceImageMasterApi.update(requestParameters)
    this.updateItem(item)
  }
}
